import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@auth0/auth0-angular';
import { legacyHubPrefixRedirect } from '@core/utils/legacy-hub-redirect';

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./features/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'subscription',
    loadChildren: () =>
      import('./features/subscription/subscription.module').then((m) => m.SubscriptionModule),
  },
  {
    path: '403',
    loadComponent: () =>
      import('./shared/features/hub-access-denied/access-denied.component').then(
        (c) => c.AccessDeniedComponent,
      ),
  },
  {
    path: '404',
    loadComponent: () =>
      import('./shared/features/hub-page-not-found/page-not-found.component').then(
        (c) => c.PageNotFoundComponent,
      ),
  },
  {
    path: 'hub',
    redirectTo: legacyHubPrefixRedirect,
  },
  // Hub is mounted at the root; its child paths (dashboard, projects, …) do not
  // collide with the siblings above, and the router backtracks out of unmatched
  // lazy children so '**' still catches garbage URLs.
  {
    path: '',
    loadChildren: () => import('./features/hub/hub.module').then((m) => m.HubModule),
    canActivate: [AuthGuard],
  },
  {
    path: '**',
    redirectTo: '404',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
